import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './Card.module.css';

const Card = ({ imgPath, title, summary, to }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.cardContainer}>
            <div className={styles.imageContainer}>
                <img src={imgPath} alt='Service img' />
            </div>
            <div className={styles.shortTitleContainer}>
                <h1>{title}</h1>
            </div>
            <div className={styles.summaryContainer}>
                <p>{summary}</p>
            </div>
            <div className={styles.buttonContainer}>
                <Link to={to} className={styles.linkBtn}>
                    {t('moreBtn')}
                </Link>
            </div>
        </div>
    );
};

export default Card;
